import state from './moduleRoleState'
import actions from './moduleRoleActions'
import getters from './moduleRoleGetters'
import mutations from './moduleRoleMutations'

export default {
  namespaced: true,
  isRegistered: false,

  state: state,
  actions: actions,
  getters: getters,
  mutations: mutations
}

